import React from 'react';
import ExternalLink from 'shared/components/Links/ExternalLink';

const COMPLIANCE_LINK = 'https://drive.google.com/open?id=1G4xlfjmlALzepXM2kT0WQRIHPFdB8ZN8';

const SplitComplianceFormLink = () => <ExternalLink to={COMPLIANCE_LINK}>LAUNCHPAD SPLIT COMPLIANCE FORM</ExternalLink>;

export default SplitComplianceFormLink;
